import { useTranslation } from "react-i18next"

type WorkflowRunOutputProps = {
  /** The run's output with any denial marker already removed. */
  output: string
  /** Denial reasons, each shown on its own line. */
  reasons: string[]
}

// A run's output as the chat run card and run history both show it: short
// single-line output stays inline, anything longer is collapsed so a whole
// email or report does not push everything below it out of view.
export function WorkflowRunOutput({ output, reasons }: WorkflowRunOutputProps) {
  const { t } = useTranslation(undefined, { keyPrefix: "workflowLanding" })
  const canExpand = output.length > 160 || output.includes("\n")

  return (
    <>
      {output && !canExpand && (
        <p className="text-muted-foreground mt-1 break-words whitespace-pre-wrap">{output}</p>
      )}
      {output && canExpand && (
        <details className="mt-1">
          <summary className="text-muted-foreground hover:text-foreground cursor-pointer text-xs">
            {t("runs.showOutput", "Show output")}
          </summary>
          <pre className="bg-muted text-muted-foreground mt-1 max-h-56 overflow-auto rounded p-2 text-[11px] break-words whitespace-pre-wrap">
            {output}
          </pre>
        </details>
      )}
      {reasons.map((reason, index) => (
        <p key={index} className="text-warning-ink mt-1 break-words whitespace-pre-wrap">
          {t("runs.denialReason", "Reason")}: {reason}
        </p>
      ))}
    </>
  )
}
